module.exports = __webpack_public_path__ + "static/media/timelapse_12.32bf44b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_12.jpg
// module id = 359
// module chunks = 0